import { TenantDto } from '@picflow/types';

export const isChecklistDone = (tenant: TenantDto) => {
  // Old customers don't need to complete the checklist
  if (tenant.created_at * 1000 < new Date('2022-04-13').getTime()) return true;

  return !!tenant.onboarding_checklist?.done;
};
